/**
 * Helpers for ordering cart items (bookings) on the cart and checkout pages.
 */

/**
 * Returns the travel date of a cart item as a number (milliseconds),
 * so two items can be compared easily.
 *
 * We prefer `travelDateWithPickupTime` because it also contains the pickup time,
 * which lets us order two bookings on the same day correctly.
 * If it is missing, we fall back to `travelDate`.
 * If both are missing, the item is pushed to the end of the list.
 */
const getTravelDateInMs = (cartItem) => {
  const travelDate = cartItem.travelDateWithPickupTime || cartItem.travelDate;

  if (!travelDate) {
    return Number.MAX_SAFE_INTEGER;
  }

  return new Date(travelDate).getTime();
};

/**
 * Returns a NEW array of cart items ordered by travel date (earliest first).
 *
 * Important: we copy the array with `[...cartItems]` before sorting,
 * because `.sort()` changes the original array. The original list is still
 * used by other code (for example `cart[0].cartID`), so we must not change it.
 */
export const sortCartByTravelDate = (cartItems) => {
  if (!Array.isArray(cartItems)) {
    return [];
  }

  return [...cartItems].sort((itemA, itemB) => {
    return getTravelDateInMs(itemA) - getTravelDateInMs(itemB);
  });
};
